import { _classes } from "../utilities/helpers";
import styles from "../../styles/widgets/Button2.scss";

const cl = _classes(styles);

Button2.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string,
  onClick: PropTypes.func,
  ariaLabel: PropTypes.string,
  disabled: PropTypes.bool,
};

Button2.defaultProps = {
  text: "Submit",
  onClick: () => null,
  disabled: false,
};

export default function Button2({
  className,
  text,
  onClick,
  ariaLabel,
  disabled,
}) {
  const numDivs = text.length % 2 === 0 ? text.length + 6 : text.length + 7;
  return (
    <div className={cl(["root", className])}>
      <button
        onClick={onClick}
        className={cl(["button", disabled ? "disabled" : ""])}
        type="submit"
        aria-label={ariaLabel}
        disabled={disabled}
      >
        <div className={cl("background")}>
          {Array.from(Array(numDivs).keys()).map((item, index) => (
            <div key={index} className={cl("block")}>
              <span data-bkg={item} className="inner"></span>
            </div>
          ))}
        </div>

        <span className={cl("text")}>{text}</span>
      </button>
    </div>
  );
}
